<template>
  <div class="markdown-editor">
    <template v-if="!edit">
      <div v-html="md_html" class="markdown-html"></div>
    </template>

    <template v-if="edit">
      <TextAreaCustom v-model="model"></TextAreaCustom>
    </template>
  </div>
</template>

<script>
import {ref, computed, watch} from "@vue/composition-api";
import TextAreaCustom from "@/components/form/TextAreaCustom";
import sanitizeHtml from 'sanitize-html';

//IMPORTANT >> migration
// two new npm packets are needed:
// npm install sanitize-html
// npm install marked

export default {

  name: 'MarkdownEditor',

  components:{
    TextAreaCustom
  },

  props:{
    edit:{
      type: Boolean,
      default: false
    },
    sanitize:{
      type: Boolean,
      default: true
    },
    value:{
      type: String,
      default: ''
    }
  },

  setup(props, {emit}){

    const marked = require("marked");

    const md_html = ref(convert(props.value));

    watch(() => props.value, () => {
      model.value = props.value;
    });

    const model = computed({
      get: () => props.value,
      set: (value) => {
        md_html.value = convert(value);
        emit('input', value);
      }
    });

    function convert(markdown){
      return props.sanitize ? sanitizeHtml(marked(markdown)) : marked(markdown);
    }

    return {md_html, model};
  }
}
</script>

<style lang="scss" scoped>
</style>
